// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"Yh","centerLink":"Zh","productSection":"_h","item":"ai","ctaButton":"bi"};